let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("czbxW")).then(() => parcelRequire('8zghZ'));